import type { StateAction } from "@entrilia/shared/types";
import type { DataImportChangesFilterValue } from "../../../../../../api/types/dataImportTypes";

export interface DataImportChangesListState {
  page: number;
  rowsPerPage: number;
  totalFilteredItems?: number;
  totalFilteredPages?: number;
  filter: DataImportChangesFilterValue | undefined;
  showChanges: boolean;
}

export const getInitialState = (
  initialFilter: DataImportChangesFilterValue | undefined
): DataImportChangesListState => ({
  page: 0,
  rowsPerPage: 100,
  filter: initialFilter,
  showChanges: true,
});

// Actions

export const changePageAction =
  (page: number): StateAction<DataImportChangesListState> =>
  (state) => ({ ...state, page });

export const changeRowsPerPageAction =
  (rowsPerPage: number): StateAction<DataImportChangesListState> =>
  (state) => ({
    ...state,
    rowsPerPage,
    page: 0,
  });

export const changeFilterAction =
  (filter: DataImportChangesFilterValue | undefined): StateAction<DataImportChangesListState> =>
  (state) => ({ ...state, filter, page: 0 });

export const updateTotalsAction =
  (total: number, totalPages: number): StateAction<DataImportChangesListState> =>
  (state) => ({
    ...state,
    page: Math.min(state.page, Math.max(totalPages - 1, 0)),
    totalFilteredItems: total,
    totalFilteredPages: totalPages,
  });

export const toggleShowChangesAction = (): StateAction<DataImportChangesListState> => (state) => ({
  ...state,
  showChanges: !state.showChanges,
});
